import PoolListCmp from '@/component/pools/PoolListCmp';

export default function PoolRewardList() {
  return <PoolListCmp type="reward" />;
}
